import React, { useEffect, useState, useReducer, useMemo } from 'react';
import { history, useIntl, getLocale } from 'umi';
import { Table } from 'tea-component';
import Filters from './components/Filters';
import CardModule from './components/CardModule';
import FixedColTable from './components/FixedColTable';
import DynamicColTableWrap from '../../components/DynamicColTable';

import { getDetailGamePathCommon } from '@/pages/intelligence/utils/topchartsUtils';
import { SUB_MODULE_CONFIG, PAGE_LOG_CONFIG_KEYS } from './config';
import useMarketFilterApi from '@/pages/intelligence/hooks/useMarketSelector';
import { transGenreSource } from '../../utils';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import { buriedPointPage } from '@/pages/home/utils/buriedPoint';
import {
  getGenreProfileDetailBigriser,
  getGenreProfileDetailNewBlockbuster,
  getGenreProfileDetailCrTen,
  getGenreProfileDetailNewRelease,
  getGenreProfileDetailUpcomming,
} from '@/pages/intelligence/services/genreProfile';

import {
  IAction,
  // IBigRiserTextBubble,
  IInsightsProps,
  ITextBubbleProp,
  ITextBubbleReturn,
  IModifiedParams,
} from '../../typings';

import './index.scss';
import { LANGUAGE_CN } from '@/pages/home/_config/config';

import { translateStateListFunc, translateStateParams, translateStateResponse } from './adapter';

const { pageable, scrollable } = Table.addons;

const reducer = (state: any, { type, payload }: IAction) => {
  return {
    ...state,
    [type]: payload,
  };
};

const Insights = (props: IInsightsProps) => {
  const {
    pcGameSegmentClassName,
    entityType,
    genreType,
    genreName,
    genreSource,
    segment,
    isMarketSegmentHide: isMarketTypeSegmentHide,
    filter: date,
    filterDispatch: dateDispatch,
  } = props;
  const { regionOptions = [] } = useMarketFilterApi({});
  const [marketType, setMarketType] = useState(segment);
  const [dataSourceSingle, setDataSourceSingle] = useState(date.dataSourceSingle);
  // const [ isMarketTypeSegmentHide, setIsMarketTypeSegmentHide ] = useState(false);
  const [BlockbusterGamesData, setBlockbusterGamesData] = useState([]);
  const [marketCRTenTableData, setMarketCRTenTableData] = useState([]);
  const [marketCRTenLineChartData, setMarketCRTenLineChartData] = useState([]);
  const [bigRiserData, setBigRiserData] = useState([]);
  const [newReleaseData, setNewReleaseData] = useState([]);
  const [upcomingData, setUpcomingDataData] = useState([]);
  const [loading, loadingDispatch] = useReducer(reducer, {
    newBlockbuster: false,
    CRTen: false,
    CRTenLine: false,
    bigRiser: false,
    newRelease: false,
    upcoming: false,
  });
  /*
  const [ date, dateDispatch ] = useReducer(reducer, {
    selected: '',
    newBlockbuster: '',
    newBlockbusterOri: '',
    CRTen: '',
    CRTenOri: '',
    bigRiser: '',
    bigRiserOri: '',
    newRelease: '',
    newReleaseOri: '',
    upcoming: '',
    upComingOri: ''
  });*/

  const [total, totalDispatch] = useReducer(reducer, {
    bigRiser: 0,
    newRelease: 0,
    upcoming: 0,
  });

  const getParams = (modifiedParams?: IModifiedParams) => {
    if (!modifiedParams) modifiedParams = {};
    return Object.assign(
      {
        regions: ['global'],
        entity_type: marketType,
        genre_tab: genreType,
        genre: genreName,
        genre_source: transGenreSource(genreSource),
        granularity: 'daily',
        start_date: date.selected,
        end_date: date.selected,
      },
      modifiedParams,
    );
  };

  const isPageLoading = useMemo(() => {
    return (
      loading.newBlockbuster ||
      loading.CRTen ||
      loading.bigRiser ||
      loading.newRelease ||
      loading.upcoming
    );
  }, [
    loading.newBlockbuster,
    loading.CRTen,
    loading.bigRiser,
    loading.newRelease,
    loading.upcoming,
  ]);

  const isMobileIegg = useMemo(() => {
    return marketType === 'mobile' && genreSource === 'iegg';
  }, [marketType, genreSource]);

  const { formatMessage } = useIntl();
  const locale = getLocale();
  const handleFilterChange = ({
    type,
    payload,
    dataSourceSingle,
  }: {
    type: 'marketType' | 'date' | 'dataSourceSingle';
    payload: any;
    dataSourceSingle?: any;
  }) => {
    const modifiedParams = {};
    switch (type) {
      case 'marketType':
        setMarketType(payload);
        Object.assign(modifiedParams, {
          entity_type: payload,
        });
        break;
      case 'date':
        dateDispatch({ type: 'selected', payload });
        Object.assign(modifiedParams, {
          start_date: payload,
          end_date: payload,
        });
        break;
      default:
    }
    if (dataSourceSingle) {
      setDataSourceSingle(dataSourceSingle);
      Object.assign(modifiedParams, {
        dataSourceSingle,
      });
    }
    initial(modifiedParams);
  };

  const handleLineChartItemClick = (date: string) => {
    setLoading({ type: 'CRTen', state: true });
    setMarketCRTen(
      {
        start_date: date,
        end_date: date,
        dataSourceSingle,
      },
      true,
    );
  };

  const handleGameItemClick = (key: string, item: any) => {
    if (!item || !item.appId) return;
    const { appId } = item || {};
    history.push(
      getDetailGamePathCommon({
        entityType: marketType,
        gameId: appId,
        tab: 'overview',
      }),
    );
  };

  const handleCr10TextClick = () => {
    history.replace(
      `/intelligence/genreProfile/pcGames/detail/stats?entityType=${marketType}&genre=${genreName}&genreType=${genreType}&source=${genreSource}`,
    );
  };

  const getTextBubble = ({ fullData, current, keyMap }: ITextBubbleProp): ITextBubbleReturn => {
    const str = current?.[keyMap.textBubble];
    const contextStrKey = SUB_MODULE_CONFIG.common.getTextBubbleTips(str);
    const textStrKey = SUB_MODULE_CONFIG.common.getTextBubbleKeyword(str);
    return {
      context: contextStrKey && formatMessage({ id: contextStrKey }),
      text: textStrKey && formatMessage({ id: textStrKey }),
      ...SUB_MODULE_CONFIG.common.getTextBubbleColor(str),
    };
  };

  // 设置日期公共方法
  const setDate = ({ type, dateStr }: { type: string; dateStr: string }) => {
    if (!dateStr) return;
    const date = SUB_MODULE_CONFIG.common.getFormattedDate(dateStr);
    dateDispatch({ type: `${type}Ori`, payload: dateStr });
    dateDispatch({ type, payload: date });
  };

  const setLoading = ({ type, state }: { type: string; state: boolean }) => {
    loadingDispatch({ type, payload: state });
  };

  const getTrueEntityType = (modifiedParams?: IModifiedParams) => {
    return modifiedParams?.entity_type || marketType || 'mobile';
  };

  const handleModuleIconClick = (type: string) => {
    let targetPageName = 'NewRelease';
    let entityName = `${entityType}Games`;
    if (type.match('upcomming')) {
      targetPageName = 'Upcoming';
    }
    if (entityType === 'total') {
      entityName = 'mobileGames';
    }
    history.replace(`/intelligence/topCharts/${entityName}/${targetPageName}`);
  };

  // 特殊列显隐规则
  const getIsHideCol = (condStr: string) => {
    if (!condStr) return false;
    const condList = condStr.split(';') || [];
    return condList.includes(marketType);
  };

  const setNewBlockbuster = (_regionOptions: any, modifiedParams?: IModifiedParams) => {
    return new Promise((resolve, reject) => {
      getGenreProfileDetailNewBlockbuster(getParams(modifiedParams))
        .then((result) => {
          try {
            const data = result?.data || {};
            const _date = data.end_date;
            const _entityType = getTrueEntityType(modifiedParams);
            setBlockbusterGamesData(
              SUB_MODULE_CONFIG.newBlockbusterGame.getFormatterTableData(
                data.games || [],
                _regionOptions,
                _entityType,
              ),
            );
            // 初始化的时候才回填时间筛选器的值
            // 这里不用setDate公共方法是因为setDate的值后续要进行中英翻译转换
            if (!date.selected) {
              dateDispatch({ type: 'selected', payload: _date });
            }
            setDate({ type: 'newBlockbuster', dateStr: _date });
            setLoading({ type: 'newBlockbuster', state: false });
            resolve(modifiedParams);
          } catch (error) {
            reject(error);
          }
        })
        .catch((error) => {
          setBlockbusterGamesData([]);
          setLoading({ type: 'newBlockbuster', state: false });
          reject(error);
        });
    });
  };

  const setMarketCRTen = (modifiedParams?: IModifiedParams, isNotNeedToSetLine?: boolean) => {
    return new Promise((resolve, reject) => {
      // dateDispatch({ type: 'CRTen', payload: '' });
      const base = getParams(modifiedParams);
      const params = translateStateParams({ dataSourceSingle, ...modifiedParams, ...base });
      const fn = translateStateListFunc(base);
      fn(params)
        .then(async (result) => {
          try {
            result = await translateStateResponse(base, params, result);
            const {
              market_cr_10_games = [],
              market_cr_10_rev_trend = [],
              start_date,
              end_date,
            } = result?.data || {};
            const { source_metrics = {} } = result?.req || {};
            const _entityType = getTrueEntityType(modifiedParams);
            const formattedTableData = SUB_MODULE_CONFIG.marketCRTenByRevenue.getFormatterTableData(
              market_cr_10_games || [],
              _entityType,
            );
            setMarketCRTenTableData(formattedTableData);
            setDate({ type: 'CRTen', dateStr: end_date });
            /** 数据传空时，将后端返回的时间填充到筛选器 */
            dateDispatch({ type: 'selected', payload: end_date });
            dateDispatch({ type: 'dataSourceSingle', payload: Object.keys(source_metrics)?.[0] || 'sensortower' });
            setLoading({ type: 'CRTen', state: false });
            if (!isNotNeedToSetLine) {
              setMarketCRTenLineChartData(market_cr_10_rev_trend);
              setLoading({ type: 'CRTenLine', state: false });
            }
            resolve(modifiedParams);
          } catch (error) {
            reject(error);
          }
        })
        .catch((error) => {
          setMarketCRTenTableData([]);
          setMarketCRTenLineChartData([]);
          setLoading({ type: 'CRTen', state: false });
          setLoading({ type: 'CRTenLine', state: false });
          reject(error);
        });
    });
  };

  const setBigRiser = (modifiedParams?: IModifiedParams) => {
    getGenreProfileDetailBigriser(getParams(modifiedParams))
      .then((result) => {
        const _entityType = getTrueEntityType(modifiedParams);
        const { games = [], date } = result?.data || {};
        const targetMetricList = SUB_MODULE_CONFIG.BigRiserGames.tableMetricList[_entityType];
        const formattedTableData = SUB_MODULE_CONFIG.BigRiserGames.preFormatter(
          games || [],
          targetMetricList,
          _entityType,
        );
        setBigRiserData(formattedTableData);
        totalDispatch({ type: 'bigRiser', payload: formattedTableData?.length });
        setDate({ type: 'bigRiser', dateStr: date });
        setLoading({ type: 'bigRiser', state: false });
      })
      .catch(() => {
        setBigRiserData([]);
        setLoading({ type: 'bigRiser', state: false });
      });
  };

  const setNewRelease = (modifiedParams?: IModifiedParams) => {
    getGenreProfileDetailNewRelease(getParams(modifiedParams))
      .then((result) => {
        const { games = [], date } = result?.data || {};
        const _entityType = getTrueEntityType(modifiedParams);
        const targetMetricList = SUB_MODULE_CONFIG.NewReleaseGames.tableMetricList[_entityType];
        const formattedTableData = SUB_MODULE_CONFIG.NewReleaseGames.preFormatter(
          games || [],
          targetMetricList,
          _entityType,
        );
        setNewReleaseData(formattedTableData);
        totalDispatch({ type: 'newRelease', payload: formattedTableData?.length });
        setDate({ type: 'newRelease', dateStr: date });
        setLoading({ type: 'newRelease', state: false });
      })
      .catch(() => {
        setNewReleaseData([]);
        setLoading({ type: 'newRelease', state: false });
      });
  };

  const setUpcoming = (modifiedParams?: IModifiedParams) => {
    getGenreProfileDetailUpcomming(getParams(modifiedParams))
      .then((result) => {
        const { games = [], date } = result?.data || {};
        const _entityType = getTrueEntityType(modifiedParams);
        const targetMetricList = SUB_MODULE_CONFIG.NewReleaseGames.tableMetricList[_entityType];
        const formattedTableData = SUB_MODULE_CONFIG.UpcomingGames.preFormatter(
          games || [],
          targetMetricList,
          _entityType,
        );
        setUpcomingDataData(formattedTableData);
        totalDispatch({ type: 'upcoming', payload: formattedTableData?.length });
        setDate({ type: 'upcoming', dateStr: date });
        setLoading({ type: 'upcoming', state: false });
      })
      .catch(() => {
        setUpcomingDataData([]);
        setLoading({ type: 'upcoming', state: false });
      });
  };

  const setInitLoading = () => {
    setLoading({ type: 'newBlockbuster', state: true });
    setLoading({ type: 'CRTen', state: true });
    setLoading({ type: 'CRTenLine', state: true });
    setLoading({ type: 'bigRiser', state: true });
    setLoading({ type: 'newRelease', state: true });
    setLoading({ type: 'upcoming', state: true });
  };

  const initial = async (modifiedParams?: IModifiedParams) => {
    if (
      loading.newBlockbuster ||
      loading.CRTen ||
      loading.bigRiser ||
      loading.newRelease ||
      loading.upcoming
    )
      return;
    const _marketType = modifiedParams?.entity_type || marketType || 'mobile';
    setInitLoading();
    if (_marketType === 'mobile' && genreSource === 'iegg') {
      // 先展示可见区域
      setMarketCRTen(modifiedParams).then(() => {
        setLoading({ type: 'newBlockbuster', state: false });
        setLoading({ type: 'bigRiser', state: false });
        setNewRelease(modifiedParams);
        setUpcoming(modifiedParams);
      });
    } else {
      // 先展示可见区域
      Promise.allSettled([
        setNewBlockbuster(regionOptions, modifiedParams),
        setMarketCRTen(modifiedParams),
      ]).then(() => {
        setBigRiser(modifiedParams);
        setNewRelease(modifiedParams);
        setUpcoming(modifiedParams);
      });
    }
  };

  useEffect(() => {
    const pageKey = marketType;
    const pageLogConfigKey = PAGE_LOG_CONFIG_KEYS[pageKey];
    const pageLogConfig = dbiPageLogMes[pageLogConfigKey];
    if (!pageLogConfig) return;
    buriedPointPage(pageLogConfig);
  }, [marketType]);

  useEffect(() => {
    Object.keys(date).forEach((key: string) => {
      if (key !== 'selected' && !key.includes('Ori')) {
        const oriKey = `${key}Ori`;
        if (!date[oriKey]) return;
        setDate({ type: key, dateStr: date[oriKey] });
      }
    });
  }, [locale]);

  useEffect(() => {
    // iegg品类的详情页，可以mobile/pc/console之间用segment切换。data.ai品类的详情页只有手游，没有game type切换。
    let type = segment;
    if (genreSource === 'annie') {
      // setIsMarketTypeSegmentHide(true);
      if (segment !== 'mobile') {
        setMarketType('mobile');
        type = 'mobile';
      }
    }
    if (!regionOptions) return;
    initial({
      entity_type: type,
    });
  }, [segment, genreSource, regionOptions]);

  return (
    <>
      <Filters
        isPageLoading={isPageLoading}
        pcGameSegmentClassName={pcGameSegmentClassName}
        marketType={marketType}
        date={date}
        isMarketTypeSegmentHide={isMarketTypeSegmentHide}
        onFilterChange={handleFilterChange}
      />
      {!isMobileIegg && (
        <CardModule
          title={`${formatMessage({ id: 'dbi_genre_profile_new_blockbuster_module_name' })}`}
          gameData={BlockbusterGamesData}
          date={date.newBlockbuster}
          isLoading={loading.newBlockbuster}
          handleTitleClick={handleGameItemClick}
          tips={`${formatMessage({
            id:
              marketType === 'mobile'
                ? 'dbi_genre_profile_new_blockbuster_games_tips'
                : 'dbi_genre_profile_new_blockbuster_pc_tip',
          })}`}
        />
      )}
      <FixedColTable
        title={`${formatMessage({ id: 'dbi_genre_profile_market_crten_module_name' })}`}
        entityType={marketType}
        tableData={marketCRTenTableData}
        lineData={marketCRTenLineChartData}
        date={date.CRTen}
        isTableLoading={loading.CRTen}
        isLineLoading={loading.CRTenLine}
        dataSource={
          marketType === 'mobile'
            ? {
                ...SUB_MODULE_CONFIG.marketCRTenByRevenue.datasource[marketType],
                value: dataSourceSingle,
              }
            : SUB_MODULE_CONFIG.marketCRTenByRevenue.datasource[marketType]
        }
        // action={SUB_MODULE_CONFIG.marketCRTenByRevenue.action}
        onTextClick={handleCr10TextClick}
        onLineChartItemClick={handleLineChartItemClick}
        onGameItemClick={handleGameItemClick}
      />
      {!isMobileIegg && (
        <DynamicColTableWrap
          key={'bigRiser'}
          title={`${formatMessage({ id: 'dbi_genre_profile_big_riser_module_name' })}${
            locale === LANGUAGE_CN ? '' : ' '
          }${formatMessage({ id: `dbi_${marketType}_games` })}`}
          tableData={bigRiserData}
          date={date.bigRiser}
          entityType={marketType}
          isLoading={loading.bigRiser}
          total={total.bigRiser}
          metricCol={
            marketType === 'mobile'
              ? SUB_MODULE_CONFIG.BigRiserGames.tableMetricList?.[`new${marketType}`](
                  dataSourceSingle,
                )
              : SUB_MODULE_CONFIG.BigRiserGames.tableMetricList?.[marketType]
          }
          isTitleCanBeClick={SUB_MODULE_CONFIG.BigRiserGames.isTitleCanBeClick}
          firstCol={SUB_MODULE_CONFIG.BigRiserGames.firstCol}
          keyMap={SUB_MODULE_CONFIG.common.dynamicTableKeyMap}
          getTextBubble={getTextBubble}
          onModuleIconClick={() => {}}
          onPagingChange={pageable}
          onSortChange={scrollable}
          onGameItemClick={handleGameItemClick}
          scrollMinWidth={1500}
        />
      )}
      {marketType !== 'mobile' && (
        <DynamicColTableWrap
          key={'newRelease'}
          tableType={'newRelease'}
          title={`${formatMessage({ id: 'dbi_genre_profile_new_release_module_name' })}${
            locale === LANGUAGE_CN ? '' : ' '
          }${formatMessage({ id: `dbi_${marketType}_games` })}`}
          tableData={newReleaseData}
          date={date.newRelease}
          entityType={marketType}
          isLoading={loading.newRelease}
          total={total.newRelease}
          isTitleCanBeClick={SUB_MODULE_CONFIG.NewReleaseGames.isTitleCanBeClick}
          metricCol={SUB_MODULE_CONFIG.NewReleaseGames.tableMetricList?.[marketType]}
          firstCol={SUB_MODULE_CONFIG.NewReleaseGames.firstCol}
          ratioHideCol={SUB_MODULE_CONFIG.NewReleaseGames.ratioHideCol}
          infoCol={SUB_MODULE_CONFIG.NewReleaseGames.infoCol}
          specialCol={SUB_MODULE_CONFIG.NewReleaseGames.specialCol}
          keyMap={SUB_MODULE_CONFIG.common.dynamicTableKeyMap}
          titleAdditionalIcon={SUB_MODULE_CONFIG.NewReleaseGames.titleAdditionalIcon}
          onModuleIconClick={handleModuleIconClick}
          getIsHideCol={getIsHideCol}
          onPagingChange={pageable}
          onSortChange={scrollable}
          onGameItemClick={handleGameItemClick}
          scrollMinWidth={1200}
        />
      )}
      {marketType !== 'mobile' && (
        <DynamicColTableWrap
          key={'upcoming'}
          tableType={'upcoming'}
          title={`${formatMessage({ id: 'dbi_genre_profile_upcoming_module_name' })}${
            locale === LANGUAGE_CN ? '' : ' '
          }${formatMessage({ id: `dbi_${marketType}_games` })}`}
          tableData={upcomingData}
          date={date.upcoming}
          entityType={marketType}
          isLoading={loading.upcoming}
          total={total.upcoming}
          isTitleCanBeClick={SUB_MODULE_CONFIG.UpcomingGames.isTitleCanBeClick}
          ratioHideCol={SUB_MODULE_CONFIG.UpcomingGames.ratioHideCol}
          metricCol={SUB_MODULE_CONFIG.UpcomingGames.tableMetricList?.[marketType]}
          firstCol={SUB_MODULE_CONFIG.UpcomingGames.firstCol}
          infoCol={SUB_MODULE_CONFIG.UpcomingGames.infoCol}
          specialCol={SUB_MODULE_CONFIG.UpcomingGames.specialCol}
          keyMap={SUB_MODULE_CONFIG.common.dynamicTableKeyMap}
          titleAdditionalIcon={SUB_MODULE_CONFIG.NewReleaseGames.titleAdditionalIcon}
          onModuleIconClick={handleModuleIconClick}
          onPagingChange={pageable}
          onSortChange={scrollable}
          onGameItemClick={handleGameItemClick}
        />
      )}
    </>
  );
};

export default Insights;
